<template>
  <Modal
    v-model="isModalOpen"
    class="modal--xlg"
  >
    <template #modal-panel>
      <div class="history-card-panel">
        <div class="modal-title-bar">
          <h1 class="history-title">
            {{ t('history-title') }}
          </h1>
          <button
            v-if="queries?.length > 0"
            class="clearHistory btn btn--danger btn--sm"
            @click.prevent="clearHistory()"
          >
            {{ t('clear-history') }}
          </button>
        </div>

        <div class="history-container">
          <div
            v-if="queries.length === 0"
            class="empty-history"
          >
            <h3>{{ t('empty-history') }}</h3>
          </div>

          <ul
            v-else
            class="history-list"
          >
            <li
              v-for="item in queries"
              :key="item.id"

              @click="selectHistoryItem(item.query)"
            >
              <div class="history-item">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.00024 6.92651H15.0001M6.8475 2.8475L6.1525 2.1525C6.05485 2.05485 5.92242 2 5.78434 2H3.08263C1.93243 2 1 2.93243 1 4.08263V11.9174C1 13.0676 1.93243 14 3.08263 14H12.9172C14.0674 14 14.9998 13.0676 14.9998 11.9174V5.08263C14.9998 3.93243 14.0674 3 12.9172 3H7.21566C7.07758 3 6.94515 2.94515 6.8475 2.8475Z"
                    stroke="#45555f"
                    stroke-width="2"
                  />
                </svg>
                <span class="history-item__text">{{ item.query }}</span>

                <span class="history-item__time">{{ formatdate(item.timestamp) }}</span>
                <button
                  aria-label="Delete single item"
                  class="delete-single-entry"
                  @click.stop.prevent="deleteHistoryItem(item.id)"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1C0.447715 1 0 1.44772 0 2C0 2.55228 0.447715 3 1 3V1ZM15 3C15.5523 3 16 2.55228 16 2C16 1.44772 15.5523 1 15 1V3ZM5 2C5 2.55228 5.44772 3 6 3C6.55228 3 7 2.55228 7 2H5ZM6 1V0H5V1H6ZM10 1H11V0H10V1ZM9 2C9 2.55228 9.44771 3 10 3C10.5523 3 11 2.55228 11 2H9ZM7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6H7ZM5 11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11H5ZM11 6C11 5.44772 10.5523 5 10 5C9.44771 5 9 5.44772 9 6H11ZM9 11C9 11.5523 9.44771 12 10 12C10.5523 12 11 11.5523 11 11H9ZM2 3V14H4V3H2ZM4 16H12V14H4V16ZM14 14V3H12V14H14ZM12 16C13.1046 16 14 15.1046 14 14H12V16ZM2 14C2 15.1046 2.89543 16 4 16V14H2ZM1 3H15V1H1V3ZM7 2V1H5V2H7ZM6 2H10V0H6V2ZM9 1V2H11V1H9ZM5 6V11H7V6H5ZM9 6V11H11V6H9Z"
                      fill="#45555f"
                    />
                  </svg>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import Modal from '#src/components/utils/Modal.vue'
import dayjs from 'dayjs'
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()
const queries = ref([])

const allQueries = JSON.parse(localStorage.getItem('queries')) || []
queries.value = allQueries.reverse()

const searchQuery = defineModel('searchQuery', String)
const isModalOpen = defineModel('isModalOpen', Boolean)

const selectHistoryItem = (clickedQuery) => {
  searchQuery.value = clickedQuery

  router.push({
    name: route.name,
    query: {
      ...route.query,
      q: clickedQuery,
      domain: 'records',
      page: 1
    }
  })

  isModalOpen.value = false
}

const clearHistory = () => {
  if (typeof window !== 'undefined' && window.confirm(t('delete-confirm'))) {
    localStorage.removeItem('queries')
    localStorage.removeItem('latestQuery')
    queries.value = []
    searchQuery.value = ''
  }
}

const { t } = useI18n({
  fallbackWarn: false,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  messages: {
    pt: {
      'history-title': 'Pesquisas Recentes',
      'notification-message.action': 'associadas automaticamente',
      'clear-history': 'Limpar Histórico',
      'empty-history': 'O Seu Histórico Está Vazio',
      'delete-confirm': 'Tem a certeza que quer limpar TODAS as pesquisas no seu Histórico?'
    },
    en: {
      'history-title': 'Recent Searches',
      'clear-history': 'Clear All History',
      'empty-history': 'Your search history is empty',
      'delete-confirm': 'Are you sure you want delete ALL queries in history?'
    }
  }
})

const formatdate = (date) => {
  return dayjs(date).format('LLLL')
}

const deleteHistoryItem = (idToRemove) => {
  if (typeof window === 'undefined') return
  let currentQueries = JSON.parse(localStorage.getItem('queries')) || []
  currentQueries = currentQueries.filter(item => item.id !== idToRemove)
  localStorage.setItem('queries', JSON.stringify(currentQueries))
  queries.value = [...currentQueries].reverse()
}
</script>

<style lang="scss" scoped>
@use "#src/assets/scss/variables" as *;

.history-list {
display: flex;
flex-flow: column nowrap;
gap: 0.5rem;
width:100%
}

.modal--xlg :deep(.modal__panel) {
justify-content: flex-start;
}

.history-title {
  text-align: center;
  margin: 0;
}

.clearHistory {
  margin-left: auto;
  align-items: center;
  justify-content: center;
}

.clearHistory:hover {
  fill: $red;
}

.history-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
}

.history-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.history-item {
display: flex;
flex-flow: row nowrap;
gap: 1rem;
border-radius: 0.5rem;
padding: 0.5rem;
align-items: center;
width:100%;
}

.history-item:hover{
  background-color: $light-blue;
}

.delete-single-entry {
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.15s ease;
  flex-shrink: 0;
}

.delete-single-entry:hover {
  background-color: $light-blue;
}

.delete-single-entry:hover svg path {
  fill: $red;
}

.history-item__text{
  width: 70%;
}
</style>
